import React from "react";
import styles from './AboutUsHome.module.css';
import img1 from '../../assets/home/aboutbale1.jpg';
import img2 from '../../assets/home/aboutbale2.jpg';
import img3 from '../../assets/home/aboutbale3.jpg';

const AboutUsHome = () =>{
    return(
        <>
            <div className={`container ${styles.contain}`}>
                <div className="row overflow-hidden">
                    <div className="col-md-6">
                        <p data-aos="slide-right" className={styles.head}>TENTANG PERUSAHAAN</p>
                        <p data-aos="slide-left" className={styles.heading}>Berpengalaman dalam penyediaan bahan bangunan untuk berbagai proyek konstruksi</p>
                        <div data-aos="zoom-in">
                            <p className={styles.content}>Bale Mart adalah mini market bahan bangunan yang menawarkan produk berkualitas dengan harga yang kompetitif. Tempat ini menjadi solusi praktis bagi kebutuhan konstruksi dan renovasi rumah, menyediakan berbagai macam produk seperti material bangunan, peralatan, hingga finishing dengan konsep minimarket. Bale Mart berdiri sejak tahun 2020 dan berinduk pada PT. Waskita Arya Rahayu Utama</p>
                        </div>
                        <div data-aos='zoom-in' style={{ textAlign: 'left' }}>
                        <a
                            href="https://wa.me/6281220209068"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ textDecoration: 'none' }} // optional: remove underline
                        >
                            <button className={`btn custom_btn ${styles.btn}`}>
                            BEKERJA DENGAN KAMI
                            </button>
                        </a>
                        </div>
                        
                    </div>

                    <div className="col-md-6 mt-5 overflow-hidden">
                        <div className={styles.row}>
                            <div className={`${styles.column} ${styles.col1}`}>
                                <img data-aos="zoom-in-right" src={img1} alt=""/>
                            </div>
                            <div className={styles.column}>
                                <img data-aos="zoom-in-left" src={img2} style={{width:'110%'}} alt=""/>
                                <img data-aos="zoom-in-left" src={img3} alt=""/>
                            </div>
    
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}

export default AboutUsHome;